import request from '../../utils/request'
//入驻设置-业务配置-支付配置
//查询机构微信相关开通信息
export function queryWxpayOrgStatus(params) {
    return request({
        url: '/setting/wxpay/apply/queryWxpayOrgStatus',
        method: 'get',
        params
    })
}

// 查询门店详情-部分
export function queryOrgInfoToContract(params) {
    return request({
        url: '/signing/eshop/tas/store/queryOrgInfoToContract',
        method: 'get',
        params
    })
}

//查询申请信息详情
export function getPartPaySettingInfo(params) {
    return request({
        url: '/setting/wxpay/apply/getInfo',
        method: 'get',
        params
    })
}

// //查看申请单最新进度  重复了
// export function queryApplyLast(params) {
//     return request({
//         url: '/setting/wxpay/apply/queryApply',
//         method: 'get',
//         params
//     })
// }

//新增信息,提交，修改
export function insert(data) {
    return request({
        url: '/setting/wxpay/apply/insert',
        method: 'post',
        data
    })
}

//
//新增信息,提交，修改  das审核可修改所有字段
export function inserts(data) {
    return request({
        url: '/setting/wxpay/apply/inserts',
        method: 'post',
        data
    })
}


// 关闭,重新开通微信开通
export function setIsUsable(usable) {
    //0,1 关闭 打开
    return request({
        url: `/setting/wxpay/apply/setIsUsable/${usable}`,
        method: 'get',
    })
}

// 取消提交
export function cancelStatus(data) {
    //0,1 关闭 打开
    return request({
        url: `/setting/wxpay/apply/status/${data.businessCode}`,
        method: 'put',
        data
    })
}

//查看申请单最新进度
export function queryWxpayApply(params) {
    return request({
        url: '/setting/wxpay/apply/queryApply',
        method: 'get',
        params
    })
}











//入驻设置-业务配置-保险配置

//查询保险配置列表
export function queryInsuranceSetting(params) {
    return request({
        url: '/setting/eshop/insurance/tasList',
        method: 'get',
        params
    })
}

//TAS-新增保险配置
export function addInsuranceSetting(data) {
    return request({
        url: '/setting/eshop/insurance/add',
        method: 'post',
        data
    })
}
// SRM -新增保险配置
export function addSrmInsuranceSetting(data) {
    return request({
        url: '/setting/eshop/insurance/addSrmInsuranceSetting',
        method: 'post',
        data
    })
}
// SRM -获取保险配置是否开启
export function getSrmInsuranceSetting() {
    return request({
        url: '/setting/eshop/insurance/getSrmInsuranceSetting',
        method: 'get',
    })
}


//TAS-删除保险配置
export function delInsuranceSetting(id) {
    return request({
        url: `/setting/eshop/insurance/delete/${id}`,
        method: 'post',
    })
}
// TAS-修改保险配置
export function updateInsuranceSetting(id) {
    return request({
        url: `/setting/eshop/insurance/update/${id}`,
        method: 'put',
    })
}
//是否打开了和包设置
export function getWarningInfo(id) {
    return request({
        url: `/setting/eshop/wallet/getInfo`,
        method: 'get',
    })
}




//结算设置-提现功能

//查询提现列表all
export function queryWithdrawalSetting(data) {
    return request({
        url: '/setting/eshop/store/withdrawal/queryWithdrawalSetting',
        method: 'get',
        data
    })
}
//查询单项提现内容
export function querySignWithdrawalSetting(query) {
    return request({
        url: '/setting/eshop/store/withdrawal/querySignWithdrawalSetting',
        method: 'get',
        params:query
    })
}
//删除提现
export function deleteWithdrawalSettingById(query) {
    return request({
        url: '/setting/eshop/store/withdrawal/deleteWithdrawalSettingById',
        method: 'get',
        params:query
    })
}
//删除所有提现
export function deleteWithdrawalSetting() {
    return request({
        url: '/setting/eshop/store/withdrawal/deleteWithdrawalSetting',
        method: 'get',
    })
}
//获取提现人员信息
export function queryUsersByOrgCode() {
    return request({
        url: '/auth/account/queryUsersByOrgCode',
        method: 'get',
    })
}

//获取提现人员信息
export function queryRoleUsersByOrgCode() {
    return request({
        url: '/auth/headquarters/queryRoleUsersByOrgCode',
        method: 'get',
    })
}


//保存提现
export function saveWithdrawalSetting(data) {
    return request({
        url: '/setting/eshop/store/withdrawal/saveWithdrawalSetting',
        method: 'post',
        data
    })
}

//变更提现配置开关
export function updatepenWithdrawal(data) {
    return request({
        url: '/setting/eshop/store/withdrawal/updatepenWithdrawal',
        method: 'get',
        params:data
    })
}

//入驻设置-店铺全局设置-装修设置

//获取基础banner
export function queryBannerSetting() {
    return request({
        url: '/setting/eshop/banner/queryBannerSetting',
        method: 'get',
    })
}
//修改基础banner
export function saveBannerSetting(data) {
    return request({
        url: '/setting/eshop/banner/saveBannerSetting',
        method: 'post',
        data
    })
}

// 运营设置-二级结算价设置

//查询二级结算价所有配置
export function querySecondarySettlement(params) {
    return request({
        url: '/auth/shopowner/querySecondarySettlement',
        method: 'get',
        params:params
    })
}

//修改btn属性 /auth/shopowner/updateSettingSaleRole
export function updateSettingSaleRole(data) {
    return request({
        url: '/auth/shopowner/updateSettingSaleRole',
        method: 'post',
        data
    })
}

//  重置二级结算价所有配置
export function clearSecondarySettlementSetting(data) {
    return request({
        url: '/auth/shopowner/clearSecondarySettlementSetting',
        method: 'get',
        params:data
    })
}

//保存单个二级结算价设置
export function saveSecondarySettlementSetting(data) {
    return request({
        url: '/auth/shopowner/saveSecondarySettlementSetting',
        method: 'post',
        data
    })
}
//查询店长二级结算价设置
export function queryStoreSecondarySettlement() {
    return request({
        url: '/auth/shopowner/queryStoreSecondarySettlement',
        method: 'get',

    })
}
//二级结算价设置成功后 同步计算最新价格调的接口
export function addSecondaryBySecondary() {
    return request({
        url: '/product/eshop/tas/secondary/addSecondaryBySecondary',
        method: 'post',
    })
}
//查询非常规订单
export function querySpecialOrderSetting() {
    return request({
        url: '/setting/eshop/store/single/querySpecialOrderSetting',
        method: 'get',
    })
}

//查询调账设置
export function queryCapitalPoolAllowNoticeSetting() {
    return request({
        url: '/setting/eshop/store/single/queryCapitalPoolAllowNoticeSetting',
        method: 'get',
    })
}

//保存单项设置 赠送保险，资金池，id，非 订单结算
export function saveSingleSetting(data) {
    return request({
        url: '/setting/eshop/store/single/saveSingleSetting',
        method: 'post',
        data
    })
}

//查询内部结算列表 TAS端查询
export function querySupplierSelfSupportArea(data) {
    return request({
        url: '/signing/eshop/tas/filterSupplier/querySupplierSelfSupportArea',
        method: 'post',
        data
    })
}

//查询内部结算列表 TAS端查询
export function orgQuerySupplierSelfSupportArea(data) {
    return request({
        url: '/signing/eshop/tas/purchaseSupplier/querySupplierSelfSupportArea',
        method: 'post',
        data
    })
}


//查询内部结算列表业务区域... TAS端查询
export function getSelfSupportArea(params) {
    return request({
        url: '/signing/eshop/tas/filterSupplier/getSelfSupport',
        method: 'get',
        params
    })
}
// 查询内部结算列表 SRM端查询
export function queryStore(data) {
    return request({
        url: '/signing/eshop/srm/filterStore/queryStore',
        method: 'post',
        data
    })
}

//添加内部结算 // no-
export function addNewSelf(data) {
    return request({
        url: '/signing/eshop/tas/self/addNewSelf',
        method: 'post',
        data
    })
}

//更新内部结算 - 非总部特许经营
export function updateInnerStatusByOrgCode(data) {
    return request({
        url: '/signing/eshop/tas/filterSupplier/updateInnerStatusByOrgCode',
        method: 'post',
        data
    })
}

//更新内部结算 - 总部特许经营
export function orgUpdateInnerStatusByOrgCode(data) {
    return request({
        url: '/signing/eshop/tas/purchaseSupplier/updateInnerStatusByOrgCode',
        method: 'post',
        data
    })
}

// 获取门店预警余额信息查询
export function getInfo(params) {
    return request({
        url: '/setting/eshop/wallet/getInfo',
        method: 'get',
        params
    })
}
//结算配置列表
export function querySettingBySupplierCode(query) {
    return request({
      url: '/setting/eshop/supplier/settlement/querySettingBySupplierCode',
      method: 'get',
      params:query
    })
}


// 新增管理员权限配置

//查询新增管理员设置结果【页面展示数据】
export function queryAllSetting(params) {
    return request({
        url: '/auth/newAdmin/queryAllSetting',
        method: 'get',
        params
    })
}

//查询新增管理员设置结果【目标结果查询】
export function queryOneSetting(data) {
    return request({
        url: '/auth/newAdmin/queryOneSetting',
        method: 'post',
        data
    })
}

//设置新增管理员权限
export function newAdminSetting(data) {
    return request({
        url: '/auth/newAdmin/setting',
        method: 'post',
        data
    })
}


// 奖励基金提现设置 
export function rewardFundWithdrawalSave(data) {
    return request({
        url: '/auth/rewardFundWithdrawal/save',
        method: 'post',
        data
    })
}




//获取总部下所有分社及直营店铺列表
export function getOrgListInHead(data) {
    console.log('传参 /auth/headquarters/getOrgList',data);
    return request({
        url: '/auth/headquarters/getOrgList',
        method: 'post',
        data
    })
}

// 根据门店编号查询所有人员信息
export function queryUsersByOrgCodeInHead(params) {
    return request({
        url: '/auth/headquarters/queryUsersByOrgCode',
        method: 'get',
        params
    })
}
// 临时订单个性化设置 save
export function tempOrderSettingSaveInHead(data) {
    return request({
        url: '/order/eshop/tas/setting/save',
        method: 'post',
        data
    })
}
// 临时订单个性化设置 query
export function tempOrderSettingQueryInHead(data) {
    return request({
        url: '/order/eshop/tas/setting/queryList',
        method: 'post',
        data
    })
}
// 取消临时订单个性化设置 delete
export function tempOrderSettingCancelInHead(data) {
    return request({
        url: `/order/eshop/tas/setting/cancel/${data}`,
        method: 'post',
    })
}

//清除所有临时订单个性化设置内容
export function tempOrderSettingClearInHead(data) {
    return request({
        url: `/order/eshop/tas/setting/clear`,
        method: 'post',
    })
}

//临时订单总开关 查询
export function getTempOrderSetting(params) {
    return request({
        url: '/auth/shopowner/getTempOrderSetting',
        method: 'post',
        // params
    })
} 
//临时订单总开关 修改
export function updateTempOrderSetting(data) {
    return request({
        url: '/auth/shopowner/updateTempOrderSetting',
        method: 'post',
        data
    })
} 

// 总部获取所有门店下账号列表
export function getUserListInHead(data) {
    return request({
        url: '/auth/headquarters/getOrgAccountList',
        method: 'post',
        data
    })
}

//系统外订单开关状态
export function updateOutsideOrderSetting(data) {
    return request({
        url: '/auth/headquarters/updateOutsideOrderSetting',
        method: 'post',
        data
    })
}
//系统外 单签合同开关状态
export function updateSingleSignContractSetting(data) {
    return request({
        url: '/auth/headquarters/updateSingleSignContractSetting',
        method: 'post',
        data
    })
}


//查询机构微信支付费率和手续费承担方
export function queryUndertakeRate(data) {
    return request({
        url: '/setting/wxpay/apply/queryUndertakeRate',
        method: 'get',
        data
    })
}

//修改机构微信支付费率和手续费承担方
export function editUndertakeRate(data) {
    return request({
        url: '/setting/wxpay/apply/editUndertakeRate',
        method: 'post',
        data
    })
}





// WEBPACK FOOTER //
// ./src/TASMini/api/setting.js